import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { SET_TRU_VALIDATE_BLACKBOX } from '../../Auth/AuthReducer'
import './TruValidate.scss'

const TruValidate = (props) => {
  const dispatch = useDispatch()
  // const {
  //   truValidateRequest: { BlackBox = {} },
  // } = useSelector((state) => state.auth, shallowEqual)
  const { TruValidateIsEnabled = false } = useSelector(
    (state) => state.app.appSettings,
    shallowEqual
  )
  const [localBlackbox, setLocalBlackbox] = useState({})
  const { children } = props

  const populateBlackBox = async () => {
    // console.log(window.IGLOO)
    if (window.IGLOO.getBlackbox) {
      const data = await window.IGLOO.getBlackbox()
      // console.log({ data })
      dispatch({ type: SET_TRU_VALIDATE_BLACKBOX, blackbox: data })
      setLocalBlackbox(data)
    }
  }

  useEffect(() => {
    if (TruValidateIsEnabled && (!localBlackbox || Object.keys(localBlackbox).length === 0))
      populateBlackBox()
  }, [localBlackbox, TruValidateIsEnabled, window.IGLOO])

  return <React.Fragment>{children}</React.Fragment>
}

export default TruValidate
